import { molsonUseTheme } from '@theme/customMuiExports'
import { ContentBox } from '../styled-components/ContentBox'

type Props = {
  children: React.ReactNode
}

export const WrapperContent = ({ children }: Props) => {
  const theme = molsonUseTheme()

  return (
    <ContentBox
      bgcolor={theme.palette.secondary[50]}
      boxShadowType="default"
      px={3}
      py={5}
      sx={{ borderRadius: 2 }}
    >
      {children}
    </ContentBox>
  )
}
